// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+Huz2","logoBlue":"Logo_logo-blue__GA1RC","logoYellow":"Logo_logo-yellow__u-sk3"};